function Breadcrumb(params) {
    return null;
}

export default Breadcrumb;